import React from 'react';
import { View, Text, Image, TouchableOpacity, StyleSheet } from 'react-native';
import { colors } from '../styles/global';

export const TopBar = ({ userName, onNotificationPress, onProfilePress }) => {
  return (
    <View style={styles.container}>
      <Text style={styles.logo}>CalendiHair</Text>
      <View style={styles.rightContent}>
        <Text style={styles.greeting}>Olá, {userName}!</Text>
        <TouchableOpacity onPress={onNotificationPress} style={styles.iconButton}>
          <Text style={styles.icon}>🔔</Text>
        </TouchableOpacity>
        <TouchableOpacity onPress={onProfilePress} style={styles.profileButton}>
          {/* Placeholder para foto do perfil */}
          <View style={styles.profilePlaceholder}>
            <Text style={styles.profileInitial}>{userName?.[0]?.toUpperCase()}</Text>
          </View>
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    height: 60,
    backgroundColor: colors.white,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 20,
    borderBottomWidth: 1,
    borderBottomColor: colors.border,
  },
  logo: {
    fontSize: 20,
    fontWeight: 'bold',
    color: colors.primary,
  },
  rightContent: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 15,
  },
  greeting: {
    fontSize: 16,
    color: colors.text,
  },
  iconButton: {
    padding: 5,
  },
  icon: {
    fontSize: 20,
  },
  profileButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    overflow: 'hidden',
  },
  profilePlaceholder: {
    width: '100%',
    height: '100%',
    backgroundColor: colors.primary,
    justifyContent: 'center',
    alignItems: 'center',
  },
  profileInitial: {
    color: colors.white,
    fontSize: 18,
    fontWeight: 'bold',
  },
});